import { useField } from "formik";
import React from "react";
import BaseElement from "components/FormElements/BaseElement";
import { packClasses } from "Util";

export default function TextArea(props) {
    const defaultProps = {
        label: "Text Area",
        id: "text-area",
        name: "text-area",
        type: "text",
        autoComplete: "off",
        value: "",
        isError: false,
        errorText: "",
        variant: false,
        onChange: () => {},
    };
    const useProps = Object.assign(defaultProps, {}, props);
    const [field, meta] = useField(props);

    const label = (
        <label
            htmlFor={useProps.id}
            className="block text-sm font-medium text-gray-700"
        >
            {props.label}
        </label>
    );

    const input = (
        <textarea
            {...field}
            {...props}
            value={field.value || ""}
            rows={useProps.rows}
            className={packClasses(
                useProps.isError || (meta.touched && meta.error)
                    ? "focus:outline-none border-red-300 text-red-900 placeholder-red-300 focus:border-red-500 focus:ring-red-500"
                    : " border-gray-300 focus:border-green-500 focus:ring-green-500",
                " block w-full rounded-md py-2 px-4 shadow-sm disabled:bg-white sm:text-sm",
                useProps.className ? useProps.className : ""
            )}
        />
    );

    const helperText = useProps.helpertext ? (
        <p className="mt-1.5 text-xs text-gray-500">{useProps.helpertext}</p>
    ) : (
        ""
    );

    const errorText =
        useProps.isError || (meta.touched && meta.error) ? (
            <p className="mt-2 text-sm text-red-600">
                {useProps.errorText}
                {meta.error}
            </p>
        ) : (
            ""
        );

    return (
        <BaseElement
            {...useProps}
            label={label}
            input={input}
            helpertext={helperText}
            errortext={errorText}
        />
    );
}
